import styled, {keyframes} from 'styled-components'
import {scrollVerticalSharedStyle} from "src/interface/scroll";

const shineLines = keyframes`
  0% {
    left: -9600px;
  }
  
  100% {
    left: 600px;
  }
`;

export const Grid = styled.div`
  /**
  вариант через flex
   */
  @media (max-width: 1130px) {
    display: flex;
    flex-wrap: wrap;
    justify-content: center;
    
    & > div:nth-child(1){
      flex-basis: 752px;
      order: 1;
      margin-right: 0;
    }
    & > div:nth-child(2){
      flex-basis: 338px;
      order: 2;
      margin-right: 14px;
      margin-left: 0;
    }
    & > div:nth-child(3){
      flex-basis: 752px;
      order: 4;
      margin-right: 0;
    }
    & > div:nth-child(4){
      flex-basis: 338px;
      order: 3;
      margin-left: 14px;
      margin-right: 0;
    }
    & > div:nth-child(5){
      flex-basis: 752px;
      order: 5;
      margin-right: 0;
    }
    & > div:nth-child(6){
      flex-basis: 752px;
      order: 6;
      margin-right: 0;
    }
  }
  /**
    вариант через grid
   */
  @media (min-width: 1130px) {
    display: grid;
    width: 100%;

    grid-Template-Columns: 684px 338px;
    gap: 0 0;
    justify-content: center;
    
    & > div:nth-child(1){
      margin-right: 14px;
    }
    & > div:nth-child(2){
      margin-left: 14px;
    }
    & > div:nth-child(3){
      margin-right: 14px;
    }
    & > div:nth-child(4){
      margin-left: 14px;
    }
    & > div:nth-child(5){
      margin-right: 14px;
    }
    & > div:nth-child(6){
      margin-left: 14px;
    }
  }
`

export const AnimatedBlock = styled.div`
  background-image: url(${props => props.img});
  background-repeat: no-repeat;
  background-size: ${props => props.width}px ${props => props.height}px;
  background-position: top left;
  overflow: hidden;
  position: relative;
  
  &:before {
    content:'';
    transform: skewX(-45deg);
    background-image: linear-gradient(90deg, transparent 0px, transparent 0px, #fff ${props => props.width * 2}px);
    position: absolute;
    background-repeat: repeat-x;
    width: ${props => props.width}px;
    height: 100%;
    animation: ${shineLines} 3.6s infinite;
  }
`

export const LeftHeader = styled.div`
  display: flex;
  width: 100%;
  font-weight: 600;
  margin: 20px 0;


  & > div:nth-child(1)
  {
    text-align: left;
    flex-basis: 40%;
    font-size: 24px;
  }
  & > div:nth-child(2)
  {
    text-align: right;
    flex-basis: 60%;
    color: #7B7B7B;
    margin-right: 35px;
    font-size: 18px;
  }
`
export const RightHeader = styled.div`
  display: flex;
  width: 100%;
  font-weight: 600;
  margin: 20px 0;


  & > div:nth-child(1)
  {
    text-align: left;
    flex-basis: 40%;
    color: #7B7B7B;
    font-size: 18px;
    margin-left: 35px;
  }
  & > div:nth-child(2)
  {
    text-align: right;
    flex-basis: 60%;
    font-size: 24px;
  }
`

export const FlexContainer = styled.div`
  display: flex;
  align-content: flex-start;
`
export const Column = styled.div`
  display: flex;
  flex-basis: 50%;
  flex-wrap: wrap;
  align-content: flex-start;
`
export const LeftList = styled.div`
  flex-basis: 100%;
  margin-bottom: 0;
  overflow: hidden;
`
export const LeftRow = styled.div`
  font-size: 14px;
  display: flex;
  width: 100%;
  position: relative;
    
  & > div:nth-child(1)
  {
    text-align: left;
    flex-basis: 18%;
  }
  & > div:nth-child(2)
  {
    text-align: left;
    flex-basis: 42%;
  }
  & > div:nth-child(3)
  {
    text-align: right;
    color: #7B7B7B;
    margin-right: 35px;
    flex-basis: 40%;
  }
  
  
  .active-name .descr{
    display:none;
    padding:10px;
    margin-top:17px;
    background:#f3f3f3;
    height:20px;
    box-shadow:0 5px 5px rgba(0,0,0,0.3);
    z-index: 100000;
  }
  
  .active-name:hover .descr{
      display:block;
      position:absolute;
      top:15px;
      z-index:9999;
      width:400px;
  }
`
export const LeftRowHeader = styled.div`
  font-size: 14px;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #D2D1D1;
  font-weight: 600;
    
  & > div:nth-child(1)
  {
    text-align: left;
    flex-basis: 18%;
  
  }
  & > div:nth-child(2)
  {
    text-align: left;
    flex-basis: 42%;
  
  }
  & > div:nth-child(3)
  {
    text-align: right;
    color: #7B7B7B;
    margin-right: 35px;
    flex-basis: 40%;
  }
`
export const LeftContainerChart = styled.div`
  flex-basis: 100%;
  overflow: hidden;
  margin-bottom: 0;
  display: flex;
`
export const LeftChart = styled.div`
  cursor: pointer;
  width: 24px;
  transition: height 1s ease;
`

export const RightList = styled.div`
  flex-basis: 100%;
  margin-bottom: 0;
  overflow: hidden;
`

export const RightRowHeader = styled.div`
  font-size: 14px;
  display: flex;
  width: 100%;
  border-bottom: 1px solid #D2D1D1;
  font-weight: 600;

  & > div:nth-child(1)
  {
    text-align: left;
    color: #7B7B7B;
    margin-left: 35px;
    flex-basis: 40%;
  }
  & > div:nth-child(2)
  {
    text-align: right;
    flex-basis: 42%;
  }
  & > div:nth-child(3)
  {
    text-align: right;
    flex-basis: 18%;
  }
`

export const RightRow = styled.div`
  display: flex;
  font-size: 14px;

  & > div:nth-child(1)
  {
    text-align: left;
    color: #7B7B7B;
    flex-basis: 40%;
    margin-left: 35px;
  }
  & > div:nth-child(2)
  {
    text-align: right;
    flex-basis: 42%;
  }
  & > div:nth-child(3)
  {
    text-align: right;
    flex-basis: 18%;
  }
`

export const RightContainerChart = styled.div`
  flex-basis: 100%;
  overflow: hidden;
  margin-bottom: 0;
  display: flex;
`

export const RightChart = styled.div`
  margin-left: auto;
  cursor: pointer;
  width: 24px;
  transition: height 1s ease;
`

export const PaymentsDashboardContainer = styled.div`
  display: flex;
  flex-wrap: wrap;
  width: 100%;
  font-size: 14px;
  align-items: start;
  flex-basis: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  margin-top: 20px;
  padding: 0;
  max-height: 280px;
  min-height: 280px;
  align-content: flex-start;
  box-sizing: border-box;

  ${scrollVerticalSharedStyle}
`
